import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Logo from '../../assets/images/purple-logo.png.png';

function PageLoader({
  message = 'Please wait',
  showMessage = false,
  isTransparent = false
}) {
  useEffect(() => {
    const { body } = document;

    body.classList.add('overflow-hidden');
    return () => {
      body.classList.remove('overflow-hidden');
    };
  }, []);

  return (
    <div
      className={`fixed left-0 top-0 !z-[99999] flex h-full w-full items-center justify-center overflow-hidden p-5 ${
        !isTransparent
          ? 'bg-white'
          : 'bg-transparent bg-opacity-95 backdrop-blur-sm backdrop-filter'
      }`}
      style={{ margin: 0 }}
    >
      <center
        className={`z-10 flex flex-col items-center justify-center ${
          showMessage ? 'gap-2' : 'gap-4'
        }`}
      >
        <div
          className={`${
            showMessage ? 'h-[76px] w-[76px]' : 'h-[132px] w-[132px]'
          } relative flex items-center justify-center`}
        >
          <div
            className={`${
              showMessage
                ? 'h-[76px] w-[76px] border-[6px]'
                : 'h-[120px] w-[120px] border-[12px]'
            } max-h-full max-w-full animate-spin rounded-full border-[#CECECE] bg-white`}
          />
          <div className="absolute flex max-h-full max-w-full animate-pulse items-center justify-center">
            <img
              src={Logo}
              className={`${
                showMessage ? 'scale-[45%]' : 'scale-[70%]'
              } animate-grow-2`}
              alt="logo"
            />
          </div>
        </div>
        {showMessage && (
          <p className="text-base font-semibold text-white md:text-2xl">
            {message}
            ...
          </p>
        )}
      </center>
    </div>
  );
}

PageLoader.propTypes = {
  message: PropTypes.string,
  showMessage: PropTypes.bool,
  isTransparent: PropTypes.bool
};

PageLoader.defaultProps = {
  message: 'Please wait',
  showMessage: false,
  isTransparent: false
};

export default PageLoader;
